import { useEffect, useState } from 'react';

const REDUCE_BIZY_MOTION_KEY = 'bizy-reduce-motion';
const BIZY_MOTION_PREFERENCE_EVENT = 'bizy-motion-preference-change';

export const getReduceBizyMotionPreference = (): boolean => {
	try {
		return localStorage.getItem(REDUCE_BIZY_MOTION_KEY) === 'true';
	} catch {
		return false;
	}
};

export const setReduceBizyMotionPreference = (value: boolean): void => {
	try {
		localStorage.setItem(REDUCE_BIZY_MOTION_KEY, String(value));
		window.dispatchEvent(new Event(BIZY_MOTION_PREFERENCE_EVENT));
	} catch {
		// localStorage unavailable
	}
};

export const useReduceBizyMotionPreference = (): [boolean, (value: boolean) => void] => {
	const [value, setValue] = useState(getReduceBizyMotionPreference);

	useEffect(() => {
		const syncValue = () => setValue(getReduceBizyMotionPreference());
		window.addEventListener('storage', syncValue);
		window.addEventListener(BIZY_MOTION_PREFERENCE_EVENT, syncValue);

		return () => {
			window.removeEventListener('storage', syncValue);
			window.removeEventListener(BIZY_MOTION_PREFERENCE_EVENT, syncValue);
		};
	}, []);

	const updateValue = (nextValue: boolean) => {
		setValue(nextValue);
		setReduceBizyMotionPreference(nextValue);
	};

	return [value, updateValue];
};
